import { createFileRoute } from '@tanstack/react-router'
import { CreateWorkspacePage } from '@/features/account/pages/create-workspace-page'

/**
 * A1/B1 — Create workspace (unified flow).
 *
 * `variant` is a dev-only preview toggle so both A1 (first-time) and B1 (repeat)
 * are viewable without needing a fresh account for A1 or a seeded one for B1.
 * Vite tree-shakes the branch out of production builds.
 */
type CreateWorkspaceSearch = {
  variant?: 'first' | 'repeat'
  /** Dev-only: renders the A3 welcome modal on top of the form so it can be
   *  visually verified without the dashboard (which needs live auth state to
   *  render). Tree-shaken in prod. The `three-ways-in` preview was removed
   *  when `ThreeWaysInCard` was superseded by the first-time-sidebar cards. */
  preview?: 'welcome'
}

export const Route = createFileRoute('/_ws/create-workspace')({
  validateSearch: (search: Record<string, unknown>): CreateWorkspaceSearch => {
    const out: CreateWorkspaceSearch = {}
    if (
      import.meta.env.DEV &&
      (search.variant === 'first' || search.variant === 'repeat')
    ) {
      out.variant = search.variant
    }
    if (import.meta.env.DEV && search.preview === 'welcome') {
      out.preview = 'welcome'
    }
    return out
  },
  component: CreateWorkspacePage,
})
